import React from 'react';
import './learningAsset.scss';
import TreeMenu from '../../common/TreeMenu';

function LearningAsset() {
  const dataTree = [
    {
      id: 1,
      title: 'Quản lý học liệu số',
      url: '/learning-assets',
      children: [],
    },
    {
      id: 2,
      title: 'Quản lý sách',
      url: '/learning-assets/learning-books',
      children: [],
    },
    {
      id: 3,
      title: 'Quản lý thẻ',
      url: '/learning-assets/tags',
      children: [],
    },
    {
      id: 4,
      title: 'Quản lý chủ đề',
      url: '/learning-assets/categories',
      children: [],
    },
    {
      id: 5,
      title: 'Chỉnh sửa nhanh',
      url: '/learning-assets/asset-tree',
      children: [],
    },
  ];
  return <TreeMenu dataTree={dataTree} />;
}

export default LearningAsset;
